import { ContentTop } from "common/src/component/ContentTop";
import GamesLoader from "common/src/component/GamesLoader";
import Lobby from "common/src/component/Lobby";
import { SERVER_SETUP, SWE_LIMIT_DIALOG } from "common/src/helpers/constants";
import { getToken } from "common/src/helpers/session";
import useGetGameLobby from "common/src/services/useGetGameLobby";
import { useEffect, useState } from "react";
import { withRouter } from "common/src/router/compat";
import {
  EmptyCategoriy,
  GameCategoryHeader,
  GameCategoryTitle,
  LobbyWrapper,
} from "common/src/styledComponents/StyledGame";
import config from "../config.json";
import { GameProvidersInLobby } from "common/src/component/GameProvidersInLobby";
import { GameThemeProviders } from "common/src/component/GameThemeProviders";
import { useTranslation } from "react-i18next";
import { ReactComponent as Telescope } from "common/src/assets/icon-component/telescope.svg";

import SeoBreadcrumbs from "common/src/component/SeoBreadcrumbs";
const Games = ({
  currency,
  server,
  searchResults,
  setSweLimitDialog,
  titles,
  width,
  player,
  skin,
  vendorsImagePath,
  setSearchResults,
  setSpinner,
  setSelectedCategory,
  selectedCategory,
  selectedGameType,
  setSelectedGameType,
}) => {
  const [serverSetup] = useState(sessionStorage.getObject(SERVER_SETUP));
  const [scrollOnBack, setScrollOnBack] = useState(false);
  const [themeSearchTerm, setThemeSearchTerm] = useState("");
  const { t } = useTranslation("");
  const [themeExists, setThemeExists] = useState(false);

  const playerCountry =
    getToken() !== null
      ? player.country
      : serverSetup.geoIP.isoCode.toLowerCase()
        ? serverSetup.geoIP.isoCode.toLowerCase()
        : config.defaultLang;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  useEffect(() => {
    setSelectedGameType(null);
    window.onpopstate = () => {
      setScrollOnBack(true);
    };
    scrollToTop();
    setSelectedCategory(null);
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [selectedGameType]);

  useEffect(() => {
    document.title = titles["games"];
  }, [titles]);

  useEffect(() => {
    if (localStorage.getItem(SWE_LIMIT_DIALOG) && getToken()) {
      setSweLimitDialog(true);
    }
  }, [setSweLimitDialog]);

  useEffect(() => {
    if (scrollOnBack) {
      scrollToTop();
    }
  }, [scrollOnBack]);

  let { orderedGameLobby, tournamentGame } = useGetGameLobby(
    playerCountry,
    "",
    config.skin,
  );

  const currentLanguage = serverSetup?.currentLanguage || "en";
  const breadcrumbItems = [
    {
      name: "Home",
      url: `/${currentLanguage}/index`,
    },
    {
      name: "Games",
      url: `/${currentLanguage}/games`,
    },
  ];

  return (
    <>
      <ContentTop
        showProfileMenu={false}
        showSearch={true}
        serverSetup={serverSetup}
        gameImagePath={config.gameImagePath}
        defaultLang={config.defaultLang}
        skin={skin}
        pages={true}
        gameSearch={true}
      />
      <SeoBreadcrumbs items={breadcrumbItems} />
      <LobbyWrapper>
        <div>
          <GameCategoryHeader provider gameTheme>
            <GameCategoryTitle category>
              {t("label_chose_provider")}
            </GameCategoryTitle>
          </GameCategoryHeader>
          <GameProvidersInLobby
            serverSetup={serverSetup}
            vendorsImagePath={vendorsImagePath}
            setSearchResults={setSearchResults}
            setSelectedGameType={setSelectedGameType}
            categoryNameForSearch={"from-game"}
            lobby={orderedGameLobby}
            clearResults={true}
            setSpinner={setSpinner}
          />
          <br></br>
          {orderedGameLobby === null ? (
            <GamesLoader skin={config.skin} />
          ) : (
            <Lobby
              gamesForCategory={false}
              gameLobby={
                selectedGameType !== null
                  ? selectedGameType
                  : orderedGameLobby.lobby
              }
              width={width}
              skin={config.skin}
              gameImagePath={config.gameImagePath}
              config={config}
              country={playerCountry}
              providerIsChosen={selectedGameType}
              setSelectedGameType={setSelectedGameType}
              selectedCategory={selectedCategory}
              themes={true}
              setThemeSearchTerm={setThemeSearchTerm}
              themeSearchTerm={themeSearchTerm}
              setSearchResults={setSearchResults}
              accountRoute={true}
              setSpinner={setSpinner}
              setThemeExists={setThemeExists}
              setSelectedCategory={setSelectedCategory}
            />
          )}
          <EmptyCategoriy
            hide={
              selectedGameType === null ||
              (selectedGameType && selectedGameType[0].games.length > 0)
            }
          >
            <Telescope />
            <div> {t("label_unable_to_find")}</div>
            <div>{t("label_unable_to_find_discription")}</div>
          </EmptyCategoriy>
          {/*{themeExists && (*/}
          {/*  <GameCategoryHeader provider gameTheme>*/}
          {/*    <GameCategoryTitle category>*/}
          {/*      {t("label_chose_theme")}*/}
          {/*    </GameCategoryTitle>*/}
          {/*  </GameCategoryHeader>*/}
          {/*)}*/}
          {/*<GameThemeProviders*/}
          {/*  setThemeSearchTerm={setThemeSearchTerm}*/}
          {/*  themeSearchTerm={themeSearchTerm}*/}
          {/*  setSearchResults={setSearchResults}*/}
          {/*  skin={config}*/}
          {/*  accountRoute={true}*/}
          {/*  serverSetup={serverSetup}*/}
          {/*  setSelectedGameType={setSelectedGameType}*/}
          {/*  setSpinner={setSpinner}*/}
          {/*  setSelectedCategory={setSelectedCategory}*/}
          {/*  setThemeExists={setThemeExists}*/}
          {/*/>*/}
        </div>
      </LobbyWrapper>
    </>
  );
};

export default withRouter(Games);
